import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled from 'styled-components';
import Navigation from './components/Navigation';
import Home from './components/Home';
import Projects from './components/Projects';
import Contact from './components/Contact';
import './App.css';

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow-x: hidden;
`;

const ContentContainer = styled.main`
  padding-top: 80px; /* Account for fixed navigation */
  min-height: calc(100vh - 80px);
`;

function App() {
  return (
    <Router>
      <AppContainer>
        <Navigation />
        <ContentContainer>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />            <Route path="/contact" element={<Contact />} />            <Route path="/github" element={() => {
              window.open('https://github.com/shardultillu', '_blank');
              return null;
            }} />
          </Routes>
        </ContentContainer>
      </AppContainer>
    </Router>
  );
}

export default App;